import { __LEGACY_STOREFRONT_SESSION_TOKEN_DATA_LOCAL_STORAGE_KEY__, NOVEL_PASS_CAMPAIGN_ID_PARAM, NOVEL_PASS_LINK_TYPE_PARAM, NOVEL_PASS_CODE_PARAM, NOVEL_SESSION_DATA_PARAM, } from "@novel/shared/utils/appConstants";
import pick from "lodash/pick";
import { parse, stringify } from "qs";
const hashProperties = [
    __LEGACY_STOREFRONT_SESSION_TOKEN_DATA_LOCAL_STORAGE_KEY__,
    NOVEL_SESSION_DATA_PARAM,
    NOVEL_PASS_CAMPAIGN_ID_PARAM,
    NOVEL_PASS_LINK_TYPE_PARAM,
    NOVEL_PASS_CODE_PARAM,
];
let hashCache = undefined;
export function getFromParsedUrlHash(prop, deleteHash = true) {
    if (!hashCache) {
        hashCache = parseUrlHash();
    }
    if (deleteHash && (hashCache === null || hashCache === void 0 ? void 0 : hashCache[prop])) {
        removeFromParsedUrlHash(prop);
    }
    return hashCache[prop];
}
export function parseUrlHash() {
    if (!hashCache) {
        if (typeof window === "undefined") {
            hashCache = {};
        }
        else {
            const rawParsedUrlHash = parse(window.location.hash.slice(1));
            // migrate legacy property
            if (rawParsedUrlHash[__LEGACY_STOREFRONT_SESSION_TOKEN_DATA_LOCAL_STORAGE_KEY__]) {
                rawParsedUrlHash[NOVEL_SESSION_DATA_PARAM] =
                    rawParsedUrlHash[__LEGACY_STOREFRONT_SESSION_TOKEN_DATA_LOCAL_STORAGE_KEY__];
                delete rawParsedUrlHash[__LEGACY_STOREFRONT_SESSION_TOKEN_DATA_LOCAL_STORAGE_KEY__];
                removeFromParsedUrlHash(__LEGACY_STOREFRONT_SESSION_TOKEN_DATA_LOCAL_STORAGE_KEY__);
            }
            hashCache = pick(rawParsedUrlHash, hashProperties);
        }
    }
    return hashCache;
}
export function removeFromParsedUrlHash(prop) {
    const parsedUrlHash = parse(window.location.hash.slice(1));
    if (Object.prototype.hasOwnProperty.call(parsedUrlHash, prop)) {
        delete parsedUrlHash[prop];
        const newHash = stringify(parsedUrlHash);
        const newHashWithSymbol = newHash ? `#${newHash}` : " ";
        history.replaceState(null, "", newHashWithSymbol);
    }
}
